(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-antes-despues"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(s) {
    if (s.dataset.listo) return;
    s.dataset.listo = '1';
    s.classList.add('pfx-js');
    function entrar() { s.classList.add('pfx-in'); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { entrar(); io.disconnect(); } }, { threshold: 0.15 });
      io.observe(s);
    } else { entrar(); }

    var celu = window.matchMedia('(max-width: 899px)');
    s.querySelectorAll('[data-comp]').forEach(function (c) {
      var ops = c.querySelectorAll('[data-ir]');
      var reloj = null;
      function poner(lado) {
        c.dataset.lado = lado;
        ops.forEach(function (o) { o.setAttribute('aria-selected', o.dataset.ir === lado ? 'true' : 'false'); });
      }
      // Alterna sola sólo en celular y mientras se ve; al primer toque queda donde la persona la dejó.
      function arrancar() {
        if (reloj || !celu.matches) return;
        reloj = setInterval(function () { poner(c.dataset.lado === 'antes' ? 'despues' : 'antes'); }, 4000);
      }
      function frenar() { clearInterval(reloj); reloj = null; }
      ops.forEach(function (o) {
        o.addEventListener('click', function () { c.dataset.tocado = '1'; frenar(); poner(o.dataset.ir); });
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          if (es[0].isIntersecting && !c.dataset.tocado) arrancar(); else frenar();
        }, { threshold: 0.5 }).observe(c);
      }
      celu.addEventListener('change', function () { if (!celu.matches) { frenar(); poner('antes'); } });
    });
  }
  function todo() { document.querySelectorAll('[data-pfx-an]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo();
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-pfx-an]');
    if (s) { delete s.dataset.listo; iniciar(s); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-barra"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciarRotacion(raiz) {
      raiz.querySelectorAll('[data-pfx-rota]:not([data-pfx-listo])').forEach(function (caja) {
        caja.setAttribute('data-pfx-listo', '');
        var mensajes = caja.querySelectorAll('.pfx-barra__r');
        if (mensajes.length < 2) return;
        var pausa = (parseFloat(caja.getAttribute('data-pausa')) || 4) * 1000;
        var actual = 0;
        setInterval(function () {
          // Con la pestaña oculta no se rota: al volver se sigue desde el mismo mensaje, sin saltos acumulados.
          if (document.hidden) return;
          var sale = mensajes[actual];
          actual = (actual + 1) % mensajes.length;
          sale.classList.remove('es-visible');
          sale.classList.add('se-va');
          setTimeout(function () { sale.classList.remove('se-va'); }, 420);
          mensajes[actual].classList.add('es-visible');
        }, pausa);
      });
    }
    function iniciar(raiz) {
      iniciarRotacion(raiz);
      raiz.querySelectorAll('[data-pfx-barra]:not([data-pfx-listo])').forEach(function (barra) {
        barra.setAttribute('data-pfx-listo', '');
        var pista = barra.querySelector('[data-pfx-pista]');
        var mitades = barra.querySelectorAll('[data-pfx-mitad]');
        if (!pista || mitades.length < 2) return;
        var velocidad = parseFloat(barra.getAttribute('data-velocidad')) || 50;

        function medir() {
          // Se parte de las mitades originales: se saca lo clonado antes y se vuelve a repetir hasta cubrir el ancho.
          mitades.forEach(function (mitad) {
            mitad.querySelectorAll('[data-pfx-clon]').forEach(function (c) { c.remove(); });
          });
          var originales = Array.prototype.slice.call(mitades[0].children);
          if (!originales.length) return;
          var ancho = mitades[0].getBoundingClientRect().width;
          if (!ancho) return;
          var vueltas = Math.max(0, Math.ceil(barra.getBoundingClientRect().width / ancho) - 1);
          for (var v = 0; v < vueltas; v++) {
            mitades.forEach(function (mitad) {
              originales.forEach(function (p) {
                var copia = p.cloneNode(true);
                copia.removeAttribute('data-shopify-editor-block');
                copia.setAttribute('data-pfx-clon', '');
                mitad.appendChild(copia);
              });
            });
          }
          var final = mitades[0].getBoundingClientRect().width;
          pista.style.setProperty('--pfx-barra-dur', (final / velocidad).toFixed(2) + 's');
        }

        medir();
        var ultimo = barra.getBoundingClientRect().width;
        window.addEventListener('resize', function () {
          var w = barra.getBoundingClientRect().width;
          if (Math.abs(w - ultimo) > 40) { ultimo = w; medir(); }
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
    else iniciar(document);
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-capturas"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.dataset.listo) return;
    raiz.dataset.listo = '1';
    var pista = raiz.querySelector('[data-pfx-wa-pista]');
    var items = Array.prototype.slice.call(raiz.querySelectorAll('[data-pfx-wa-item]'));
    var ant = raiz.querySelector('[data-pfx-wa-ant]');
    var sig = raiz.querySelector('[data-pfx-wa-sig]');
    var puntos = raiz.querySelector('[data-pfx-wa-puntos]');
    if (!pista || !items.length) return;
    items.forEach(function () { puntos.appendChild(document.createElement('i')); });
    var marcas = puntos.children;

    function actual() {
      var izq = pista.getBoundingClientRect().left;
      var mejor = 0, menor = Infinity;
      items.forEach(function (el, i) {
        var d = Math.abs(el.getBoundingClientRect().left - izq);
        if (d < menor) { menor = d; mejor = i; }
      });
      return mejor;
    }
    function pintar() {
      var i = actual();
      var sobra = pista.scrollWidth - pista.clientWidth;
      raiz.classList.toggle('pfx-wa--mandos', sobra > 4);
      items.forEach(function (el, n) { el.classList.toggle('act', n === i); marcas[n].classList.toggle('act', n === i); });
      ant.disabled = pista.scrollLeft < 4;
      sig.disabled = pista.scrollLeft > sobra - 4;
    }
    function ir(paso) {
      var destino = items[Math.max(0, Math.min(items.length - 1, actual() + paso))];
      var calmo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      pista.scrollTo({ left: pista.scrollLeft + destino.getBoundingClientRect().left - pista.getBoundingClientRect().left, behavior: calmo ? 'auto' : 'smooth' });
    }
    ant.addEventListener('click', function () { ir(-1); });
    sig.addEventListener('click', function () { ir(1); });
    var espera;
    pista.addEventListener('scroll', function () { cancelAnimationFrame(espera); espera = requestAnimationFrame(pintar); }, { passive: true });
    window.addEventListener('resize', pintar);
    pintar();
  }
  function todos() { document.querySelectorAll('[data-pfx-wa]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos); else todos();
  document.addEventListener('shopify:section:load', todos);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-comparativa"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(el) {
    if (el.dataset.pfxCmpListo) return;
    el.dataset.pfxCmpListo = '1';
    el.classList.add('pfx-cmp--js');
    if (!('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) { el.classList.add('is-in'); io.disconnect(); }
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    io.observe(el);
  }
  function todas() { document.querySelectorAll('[data-pfx-cmp]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas); else todas();
  document.addEventListener('shopify:section:load', todas);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(el) {
    if (el.dataset.pfxFaqListo) return;
    el.dataset.pfxFaqListo = '1';
    var items = Array.prototype.slice.call(el.querySelectorAll('.pfx-faq__item'));
    var soloUna = el.getAttribute('data-una') !== 'false';
    var primera = el.getAttribute('data-primera') === 'true';

    function poner(item, abierto) {
      item.classList.toggle('is-open', abierto);
      var b = item.querySelector('.pfx-faq__q');
      if (b) b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    }
    // Sin JS todo queda abierto; recién acá se cierran las que corresponde.
    el.classList.add('pfx-faq--js');
    items.forEach(function (it, i) {
      poner(it, primera && i === 0);
      var b = it.querySelector('.pfx-faq__q');
      if (!b) return;
      b.addEventListener('click', function () {
        var abrir = !it.classList.contains('is-open');
        if (abrir && soloUna) items.forEach(function (o) { if (o !== it) poner(o, false); });
        poner(it, abrir);
      });
    });

    if (!('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) { el.classList.add('is-in'); io.disconnect(); }
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    io.observe(el);
  }
  function todas() { document.querySelectorAll('[data-pfx-faq]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas); else todas();
  document.addEventListener('shopify:section:load', todas);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-garantia"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function iniciar(raiz) {
      raiz.querySelectorAll('[data-pfx-gar]:not([data-pfx-listo])').forEach(function (sec) {
        sec.setAttribute('data-pfx-listo', '');
        if (reducido) sec.setAttribute('data-reducido', '');
        sec.classList.add('pfx-gar--oculta');

        var puntos = Array.prototype.slice.call(sec.querySelectorAll('.pfx-gar__punto'));
        var pasos = Array.prototype.slice.call(sec.querySelectorAll('[data-pfx-gar-paso]'));
        var cuenta = sec.querySelector('[data-pfx-gar-cuenta]');
        var sello = sec.querySelector('[data-pfx-gar-sello]');
        var grilla = sec.querySelector('[data-pfx-gar-grilla]');
        var timers = [];

        function paso(k) {
          var el = pasos[k - 1];
          if (el) el.classList.add('pfx-gar--on');
        }

        function secuencia() {
          timers.forEach(clearTimeout); timers = [];
          puntos.forEach(function (p) { p.classList.remove('pfx-gar--on'); });
          pasos.forEach(function (p) { p.classList.remove('pfx-gar--on'); });
          if (sello) sello.classList.remove('pfx-gar--on');
          if (cuenta) cuenta.textContent = '0';
          sec.classList.add('pfx-gar--armada');
          var paso_ini = 500, cada = 18;
          puntos.forEach(function (p, i) {
            timers.push(setTimeout(function () {
              p.classList.add('pfx-gar--on');
              if (cuenta) cuenta.textContent = i + 1;
              var k = p.getAttribute('data-paso');
              if (k) paso(+k);
            }, paso_ini + i * cada));
          });
          var fin = paso_ini + puntos.length * cada + 200;
          timers.push(setTimeout(function () {
            if (sello) sello.classList.add('pfx-gar--on');
            // Los pasos sin día propio se encienden al cerrar, junto al sello.
            pasos.forEach(function (el, i) {
              if (!sec.querySelector('.pfx-gar__punto[data-paso="' + (i + 1) + '"]')) {
                timers.push(setTimeout(function () { paso(i + 1); }, 300 + i * 120));
              }
            });
          }, fin));
        }

        function entrar() {
          sec.classList.remove('pfx-gar--oculta');
          sec.classList.add('pfx-gar--lista');
          timers.push(setTimeout(secuencia, 100));
        }

        if (grilla) {
          grilla.addEventListener('click', secuencia);
          grilla.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); secuencia(); }
          });
        }
        pasos.forEach(function (el) { el.addEventListener('click', secuencia); });

        if ('IntersectionObserver' in window) {
          var obs = new IntersectionObserver(function (es) {
            if (es.some(function (e) { return e.isIntersecting; })) { obs.disconnect(); entrar(); }
          }, { threshold: 0.3 });
          obs.observe(sec);
        } else {
          entrar();
        }
      });
    }

    iniciar(document);
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target || document); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ---------- Entrada: sale oculta y aparece en cascada, una sola vez ----------
    function iniciarEntrada(hero) {
      hero.querySelectorAll('.pfx-hero__beneficios li').forEach(function (li, i) {
        li.querySelectorAll('.pfx-hero__check').forEach(function (c) { c.style.setProperty('--pfx-k', i); });
      });
      hero.classList.add('pfx-hero--oculta');
      var mostrar = function () {
        if (hero.classList.contains('pfx-hero--lista')) return;
        hero.classList.add('pfx-hero--lista');
        setTimeout(function () { hero.classList.add('pfx-hero--quieta'); }, 1500);
      };
      requestAnimationFrame(function () { requestAnimationFrame(mostrar); });
      setTimeout(mostrar, 400);
    }

    // ---------- Galería: fundido con escala, flechas, miniaturas, teclado y arrastre ----------
    function iniciarGaleria(galeria) {
      var slides = Array.prototype.slice.call(galeria.querySelectorAll('.pfx-hero__slide'));
      var minis = Array.prototype.slice.call(galeria.querySelectorAll('[data-pfx-mini]'));
      var cuenta = galeria.querySelector('[data-pfx-cuenta]');
      var marco = galeria.querySelector('[data-pfx-marco]');
      var tira = galeria.querySelector('[data-pfx-minis]');
      var total = slides.length;
      if (!total) return;
      var actual = 0;
      galeria.setAttribute('data-listo', '');
      function dos(n) { return (n < 10 ? '0' : '') + n; }
      function ir(k) {
        k = (k + total) % total;
        actual = k;
        slides.forEach(function (s, i) { s.classList.toggle('pfx-hero__slide--activa', i === k); });
        minis.forEach(function (m, i) { m.setAttribute('aria-current', i === k ? 'true' : 'false'); });
        var foto = minis[k] && minis[k].querySelector('img'); galeria.toggleAttribute('data-flechas-abajo', !!(foto && /ingredientes-0111/.test(foto.currentSrc || foto.src))); if (cuenta) cuenta.textContent = dos(k + 1) + ' / ' + dos(total);
        if (tira && minis[k]) {
          var m = minis[k];
          tira.scrollTo({ left: m.offsetLeft - (tira.clientWidth - m.offsetWidth) / 2, behavior: 'auto' });
        }
      }
      ir(0);
      minis.forEach(function (m, i) { m.addEventListener('click', function () { ir(i); }); });
      var ant = galeria.querySelector('[data-pfx-ant]');
      var sig = galeria.querySelector('[data-pfx-sig]');
      if (ant) ant.addEventListener('click', function () { ir(actual - 1); });
      if (sig) sig.addEventListener('click', function () { ir(actual + 1); });
      if (marco) {
        marco.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); ir(actual + 1); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); ir(actual - 1); }
        });
        var x0 = null;
        marco.addEventListener('pointerdown', function (e) { if (e.target.closest('button')) return; x0 = e.clientX; });
        marco.addEventListener('pointerup', function (e) {
          if (x0 === null) return;
          var dx = e.clientX - x0;
          x0 = null;
          if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1));
        });
        marco.addEventListener('pointercancel', function () { x0 = null; });
      }
    }

    // ---------- Contador de lanzamiento ----------
    function dos(n) { return (n < 10 ? '0' : '') + n; }

    // El dígito nuevo entra con un giro corto; en reducido, menos recorrido.
    function cambiarNumero(caja, texto) {
      var viejo = caja.lastElementChild;
      if (viejo && viejo.textContent === texto) return;
      if (!viejo || !caja.getAttribute('data-listo')) { caja.innerHTML = ''; var s0 = document.createElement('span'); s0.textContent = texto; caja.appendChild(s0); caja.setAttribute('data-listo', '1'); return; }
      var nuevo = document.createElement('span');
      nuevo.textContent = texto;
      caja.appendChild(nuevo);
      var dy = reducido ? 25 : 70;
      var opciones = { duration: 260, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'both' };
      nuevo.animate([{ opacity: 0, transform: 'translateY(' + dy + '%) rotateX(-60deg)' }, { opacity: 1, transform: 'none' }], opciones);
      var salida = viejo.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(' + (-dy) + '%) rotateX(60deg)' }], opciones);
      salida.onfinish = function () { if (viejo.parentNode) viejo.parentNode.removeChild(viejo); };
    }

    function iniciarContador(tarjeta) {
      var reloj = tarjeta.querySelector('[data-pfx-reloj]');
      if (!reloj) return;
      var fin = Date.parse(tarjeta.getAttribute('data-fin'));
      // Sin fecha válida no hay cronómetro: la tarjeta queda sólo con su texto.
      if (isNaN(fin)) { reloj.hidden = true; return; }
      var cajas = { d: reloj.querySelector('[data-pfx-num="d"]'), h: reloj.querySelector('[data-pfx-num="h"]'), m: reloj.querySelector('[data-pfx-num="m"]') };
      var temporizador = null;
      function tic() {
        var resto = fin - Date.now();
        if (resto <= 0) {
          reloj.hidden = true;
          if (temporizador) clearInterval(temporizador);
          return;
        }
        var min = Math.floor(resto / 60000);
        cambiarNumero(cajas.d, dos(Math.floor(min / 1440)));
        cambiarNumero(cajas.h, dos(Math.floor((min % 1440) / 60)));
        cambiarNumero(cajas.m, dos(min % 60));
      }
      tic();
      if (!reloj.hidden) temporizador = setInterval(tic, 1000);
    }

    // ---------- Packs: cantidad (y variante, si el pack trae una) + precio en el botón ----------
    function iniciarCompra(form) {
      var cantidad = form.querySelector('[data-pfx-cantidad]');
      var variante = form.querySelector('[data-pfx-variante]');
      var unidades = form.querySelector('[data-pfx-unidades]');
      var base = form.getAttribute('data-variante-base');
      var radios = form.querySelectorAll('.pfx-hero__pack-input');
      var precioBoton = form.querySelector('[data-pfx-precio-boton]');
      function sincronizar() {
        var marcado = form.querySelector('.pfx-hero__pack-input:checked');
        if (!marcado && radios.length) { marcado = radios[0]; marcado.checked = true; }
        if (!marcado) return;
        cantidad.value = marcado.value;
        variante.value = marcado.getAttribute('data-variante') || base;
        // Logística arma el pedido por frascos: sin dato, el input queda deshabilitado y no ensucia la línea.
        if (unidades) { unidades.value = marcado.getAttribute('data-unidades') || ''; unidades.disabled = !unidades.value; }
        var valor = marcado.closest('.pfx-hero__pack').querySelector('[data-pfx-valor]');
        if (precioBoton && valor) {
          var texto = valor.textContent.trim();
          if (precioBoton.textContent !== texto) {
            if (!precioBoton.textContent || !precioBoton.getAttribute('data-listo')) { precioBoton.textContent = texto; precioBoton.setAttribute('data-listo', '1'); }
            else contarPrecio(precioBoton, texto);
            valor.classList.remove('pfx-hero__pop');
            void valor.offsetWidth;
            valor.classList.add('pfx-hero__pop');
          }
        }
      }

      // El precio del botón cuenta desde el anterior hasta el del pack elegido, con el mismo formato (puntos de miles).
      var contando = 0;
      function contarPrecio(el, texto) {
        var re = /\d[\d.]*/;
        var a = re.exec(el.textContent), b = re.exec(texto);
        cancelAnimationFrame(contando);
        if (!a || !b) { el.textContent = texto; return; }
        var desde = parseInt(a[0].replace(/\./g, ''), 10), hasta = parseInt(b[0].replace(/\./g, ''), 10);
        if (isNaN(desde) || isNaN(hasta)) { el.textContent = texto; return; }
        var antes = texto.slice(0, b.index), despues = texto.slice(b.index + b[0].length);
        var t0 = null, dur = 280;
        function paso(t) {
          if (t0 === null) t0 = t;
          var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
          var n = Math.round(desde + (hasta - desde) * e);
          el.textContent = p < 1 ? antes + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + despues : texto;
          if (p < 1) contando = requestAnimationFrame(paso);
        }
        contando = requestAnimationFrame(paso);
      }

      // Botón: estados cargando -> tilde.
      var boton = form.querySelector('.pfx-hero__boton');
      var reinicio = null;
      if (boton) {
        var estado = document.createElement('span');
        estado.className = 'pfx-hero__boton-estado';
        estado.setAttribute('aria-hidden', 'true');
        estado.innerHTML = '<svg viewBox="0 0 24 24"><circle class="pfx-hero__spin" cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-dasharray="40 100"/><path class="pfx-hero__ok" pathLength="1" d="m6.5 12.5 3.8 3.8 7.2-8" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="pfx-hero__t-cargando"></span><span class="pfx-hero__t-hecho"></span>';
        estado.querySelector('.pfx-hero__t-cargando').textContent = boton.getAttribute('data-texto-cargando') || '';
        estado.querySelector('.pfx-hero__t-hecho').textContent = boton.getAttribute('data-texto-hecho') || '';
        boton.appendChild(estado);
      }
      function mostrarEstado(simulado) {
        if (!boton) return;
        clearTimeout(reinicio);
        boton.setAttribute('data-estado', 'cargando');
        boton.setAttribute('aria-busy', 'true');
        if (simulado) {
          reinicio = setTimeout(function () {
            boton.setAttribute('data-estado', 'hecho');
            boton.removeAttribute('aria-busy');
            reinicio = setTimeout(function () { boton.removeAttribute('data-estado'); }, 1800);
          }, 1000);
        }
      }

      form.addEventListener('change', sincronizar);
      form.addEventListener('submit', function (e) {
        // En la vista previa local no hay carrito: no se navega a una ruta que no existe, y el aviso se simula.
        if (location.protocol === 'file:') { e.preventDefault(); mostrarEstado(true); return; }
        var marcado = form.querySelector('.pfx-hero__pack-input:checked');
        var codigo = marcado ? (marcado.getAttribute('data-codigo') || '').trim() : '';
        mostrarEstado(false);
        // Sin código, el envío común del formulario alcanza. Con código, el precio del pack sale del
        // descuento: se agrega por AJAX y se aplica el código antes de ir al carrito, como la ficha vieja.
        if (!codigo) return;
        e.preventDefault();
        var raizTienda = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
        fetch(raizTienda + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: json,
          body: JSON.stringify({ items: [Object.assign({ id: Number(variante.value), quantity: Number(cantidad.value) }, unidades && unidades.value ? { properties: { Unidades: unidades.value } } : {})] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add'); })
          .then(function () {
            return fetch(raizTienda + 'cart/update.js', {
              method: 'POST', credentials: 'same-origin', headers: json, body: JSON.stringify({ discount: codigo })
            });
          })
          .catch(function () {})
          .then(function () { location.href = raizTienda + 'cart'; });
      });
      sincronizar();
    }

    // ---------- Acordeones con altura real animada ----------
    function iniciarAcordeon(d) {
      var resumen = d.querySelector('summary');
      var anim = null;
      var duracion = reducido ? 200 : 280;
      resumen.addEventListener('click', function (e) {
        e.preventDefault();
        var h0 = d.getBoundingClientRect().height;
        if (anim) { anim.cancel(); anim = null; }
        var cerrar = d.open && d.getAttribute('data-cerrando') !== '1';
        d.style.overflow = 'hidden';
        var h1;
        if (cerrar) {
          d.setAttribute('data-cerrando', '1');
          h1 = resumen.offsetHeight + (d.offsetHeight - d.clientHeight);
        } else {
          d.removeAttribute('data-cerrando');
          d.open = true;
          h1 = d.offsetHeight;
        }
        anim = d.animate({ height: [h0 + 'px', h1 + 'px'] }, { duration: duracion, easing: 'cubic-bezier(.23, 1, .32, 1)' });
        anim.onfinish = function () {
          if (cerrar) d.open = false;
          d.removeAttribute('data-cerrando');
          d.style.overflow = '';
          anim = null;
        };
      });
    }

    function iniciar(raiz) {
      raiz.querySelectorAll('[data-pfx-hero]:not([data-pfx-listo])').forEach(function (hero) {
        hero.setAttribute('data-pfx-listo', '');
        if (reducido) hero.setAttribute('data-reducido', '');
        iniciarEntrada(hero);
        hero.querySelectorAll('[data-pfx-galeria]').forEach(iniciarGaleria);
        hero.querySelectorAll('[data-pfx-lanzamiento]').forEach(iniciarContador);
        hero.querySelectorAll('[data-pfx-compra]').forEach(iniciarCompra);
        hero.querySelectorAll('[data-pfx-ac]').forEach(iniciarAcordeon);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
    else iniciar(document);
    // En el editor de temas la sección se vuelve a pintar sin recargar la página.
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-home-formula"] && !Shopify.designMode) return;
  try {
    
(function () {
  function formato(n) {
    var r = Math.round(n * 10) / 10;
    var t = (r % 1 === 0 ? String(r) : r.toFixed(1).replace('.', ','));
    return t.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function iniciar(el) {
    if (el.dataset.pfxHfListo) return;
    el.dataset.pfxHfListo = '1';
    var filas = Array.prototype.slice.call(el.querySelectorAll('.pfx-hf__fila'));
    var fichas = Array.prototype.slice.call(el.querySelectorAll('.pfx-hf__ficha'));
    if (!filas.length) return;

    // El total se suma desde los bloques, así editar un mg lo actualiza solo.
    var total = filas.reduce(function (s, f) { return s + (parseFloat(f.getAttribute('data-mg')) || 0); }, 0);
    var elTotal = el.querySelector('.pfx-hf__total b');
    var activa = 0, parado = false, visible = false, temporizador = null, tPrev = null;

    el.classList.add('pfx-hf--js');
    if (elTotal) elTotal.textContent = formato(0);

    function contar() {
      if (!elTotal) return;
      var dur = 800, ini = null;
      function paso(t) {
        if (ini === null) ini = t;
        var p = Math.min(1, (t - ini) / dur);
        elTotal.textContent = formato(total * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(paso); else elTotal.textContent = formato(total);
      }
      requestAnimationFrame(paso);
    }

    function mostrar(i, animar) {
      if (i === activa && animar !== 'forzar') return;
      var vieja = fichas[activa];
      fichas.forEach(function (f) { f.classList.remove('is-prev', 'is-entra'); });
      if (vieja && i !== activa) vieja.classList.remove('is-act'), vieja.classList.add('is-prev');
      filas.forEach(function (f, k) {
        var on = k === i;
        f.classList.toggle('is-act', on);
        f.setAttribute('aria-selected', on ? 'true' : 'false');
        f.setAttribute('tabindex', on ? '0' : '-1');
      });
      activa = i;
      var nueva = fichas[i];
      if (!nueva) return;
      nueva.classList.add('is-act');
      void nueva.offsetWidth;
      nueva.classList.add('is-entra');
      clearTimeout(tPrev);
      tPrev = setTimeout(function () { if (vieja) vieja.classList.remove('is-prev'); }, 520);
    }

    function parar() { parado = true; clearTimeout(temporizador); }
    function programar() {
      if (parado || el.getAttribute('data-auto') === 'false' || filas.length < 2) return;
      var seg = parseFloat(el.getAttribute('data-seg')) || 4;
      temporizador = setTimeout(function () {
        if (parado) return;
        if (visible && !document.hidden) mostrar((activa + 1) % filas.length);
        programar();
      }, seg * 1000);
    }

    filas.forEach(function (f, i) {
      f.addEventListener('click', function () { parar(); mostrar(i); });
      f.addEventListener('keydown', function (e) {
        var k = e.key, n = -1;
        if (k === 'ArrowDown' || k === 'ArrowRight') n = (i + 1) % filas.length;
        else if (k === 'ArrowUp' || k === 'ArrowLeft') n = (i - 1 + filas.length) % filas.length;
        else if (k === 'Home') n = 0;
        else if (k === 'End') n = filas.length - 1;
        if (n < 0) return;
        e.preventDefault(); parar(); mostrar(n); filas[n].focus();
      });
    });
    el.addEventListener('pointerdown', parar);
    el.addEventListener('keydown', parar);

    function entrar() {
      el.classList.add('is-in');
      if (fichas[activa]) fichas[activa].classList.add('is-entra');
      setTimeout(contar, 900);
      setTimeout(programar, 1600);
    }
    if (!('IntersectionObserver' in window)) { visible = true; entrar(); return; }
    var primera = true;
    new IntersectionObserver(function (e) {
      visible = e[0].isIntersecting;
      if (visible && primera) { primera = false; entrar(); }
    }, { threshold: 0.2 }).observe(el);
  }
  function todas() { document.querySelectorAll('[data-pfx-hf]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas); else todas();
  document.addEventListener('shopify:section:load', todas);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-home-momentos"] && !Shopify.designMode) return;
  try {
    
(function () {
  var NS = 'http://www.w3.org/2000/svg';

  function iniciar(el) {
    if (el.dataset.pfxHmomListo) return;
    el.dataset.pfxHmomListo = '1';
    var cielo = el.querySelector('[data-pfx-hmom-cielo]');
    var lista = el.querySelector('[data-pfx-hmom-lista]');
    el.classList.add('pfx-hmom--js');
    if (!cielo || !lista) {
      mostrarAlEntrar(el, function () {});
      return;
    }
    var tabs = [].slice.call(lista.querySelectorAll('[role="tab"]'));
    var paneles = [].slice.call(el.querySelectorAll('[role="tabpanel"]'));
    var capas = [].slice.call(cielo.querySelectorAll('.pfx-hmom__capa'));
    var svg = cielo.querySelector('svg');
    var trazos = [].slice.call(svg.querySelectorAll('path'));
    var avances = [].slice.call(svg.querySelectorAll('.pfx-hmom__avance'));
    var paradas = svg.querySelector('.pfx-hmom__paradas');
    var punto = svg.querySelector('.pfx-hmom__punto');
    var n = tabs.length;
    var actual = 0, cortado = false, largo = 1, puntos = [], reloj = 0;

    // El arco se calcula con el tamaño real para que el punto no se deforme en celular.
    function trazar() {
      var W = cielo.clientWidth, H = cielo.clientHeight;
      if (!W || !H) return;
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      var d = 'M' + (W * .07).toFixed(1) + ' ' + (H * .82).toFixed(1) + ' Q' + (W / 2).toFixed(1) + ' ' + (-H * .5).toFixed(1) + ' ' + (W * .93).toFixed(1) + ' ' + (H * .82).toFixed(1);
      trazos.forEach(function (p) { p.setAttribute('d', d); });
      largo = trazos[0].getTotalLength();
      puntos = [];
      paradas.textContent = '';
      for (var i = 0; i < n; i++) {
        var pt = trazos[0].getPointAtLength(largo * (n > 1 ? i / (n - 1) : 0));
        puntos.push(pt);
        var c = document.createElementNS(NS, 'circle');
        c.setAttribute('class', 'pfx-hmom__parada');
        c.setAttribute('cx', pt.x); c.setAttribute('cy', pt.y); c.setAttribute('r', 3.5);
        paradas.appendChild(c);
        if (W < 600) continue;
        var tx = document.createElementNS(NS, 'text');
        tx.setAttribute('class', 'pfx-hmom__rotulo');
        tx.setAttribute('x', pt.x); tx.setAttribute('y', pt.y + 26);
        tx.setAttribute('text-anchor', i === 0 ? 'start' : (i === n - 1 ? 'end' : 'middle'));
        if (i === 0) tx.setAttribute('x', pt.x - 4); if (i === n - 1) tx.setAttribute('x', pt.x + 4);
        tx.textContent = tabs[i].querySelector('.pfx-hmom__etiqueta').textContent;
        paradas.appendChild(tx);
      }
      mover(true);
    }

    function mover(sin) {
      var pt = puntos[actual]; if (!pt) return;
      if (sin) punto.style.transition = 'none';
      punto.style.transform = 'translate(' + pt.x + 'px,' + pt.y + 'px)';
      avances.forEach(function (a) { a.style.strokeDashoffset = n > 1 ? 1 - actual / (n - 1) : 1; });
      if (sin) { void punto.getBoundingClientRect(); punto.style.transition = ''; }
    }

    function ir(i, manual) {
      actual = (i + n) % n;
      tabs.forEach(function (t, k) {
        var on = k === actual;
        t.classList.toggle('is-activo', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      paneles.forEach(function (p, k) { p.classList.toggle('is-activo', k === actual); });
      capas.forEach(function (c, k) { c.classList.toggle('is-activo', k === actual); });
      cielo.setAttribute('data-oscuro', capas[actual] && capas[actual].getAttribute('data-oscuro') === 'true' ? 'true' : 'false');
      mover(false);
      if (!manual && el.classList.contains('pfx-hmom--auto')) { reiniciarBarra(); programar(); }
    }

    // Reinicia la animación de la barrita de la pestaña activa.
    function reiniciarBarra() {
      var b = tabs[actual].querySelector('.pfx-hmom__barra');
      b.style.animation = 'none'; void b.offsetWidth; b.style.animation = '';
    }

    // El reloj manda el cambio; la barrita es sólo el reflejo visual de ese tiempo.
    function programar() {
      clearTimeout(reloj);
      reloj = setTimeout(function () { if (!cortado) ir(actual + 1, false); }, 3500);
    }

    function cortar() {
      if (cortado) return;
      cortado = true;
      clearTimeout(reloj);
      el.classList.remove('pfx-hmom--auto');
    }

    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { cortar(); ir(k, true); });
    });
    lista.addEventListener('keydown', function (e) {
      var k = tabs.indexOf(document.activeElement);
      if (k < 0) return;
      var sig = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') sig = k + 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') sig = k - 1;
      else if (e.key === 'Home') sig = 0;
      else if (e.key === 'End') sig = n - 1;
      if (sig === null) return;
      e.preventDefault(); cortar(); ir(sig, true); tabs[actual].focus();
    });
    ['pointerdown', 'touchstart'].forEach(function (ev) { el.addEventListener(ev, cortar, { passive: true }); });

    trazar();
    ir(0, true);
    if (window.ResizeObserver) new ResizeObserver(function () { trazar(); }).observe(cielo);
    else window.addEventListener('resize', trazar);

    mostrarAlEntrar(el, function () { if (cortado) return; el.classList.add('pfx-hmom--auto'); reiniciarBarra(); programar(); });
  }

  // Una sola vez al entrar en pantalla; sin IntersectionObserver se muestra ya.
  function mostrarAlEntrar(el, alEntrar) {
    function entrar() { el.classList.add('is-in'); alEntrar(); }
    if (!('IntersectionObserver' in window)) { entrar(); return; }
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); entrar(); }
    }, { threshold: .12, rootMargin: '0px 0px -6% 0px' });
    io.observe(el);
  }

  function todas() { [].slice.call(document.querySelectorAll('[data-pfx-hmom]')).forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas); else todas();
  document.addEventListener('shopify:section:load', todas);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-home-portada"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Resorte amortiguado en keyframes multipunto (500 ms) o fundido corto si hay reduced motion.
  function entrar(el, retraso, desde) {
    if (!el || !el.animate) { if (el) el.style.opacity = 1; return; }
    var kf = reducido
      ? [{ opacity: 0 }, { opacity: 1 }]
      : [
          { transform: 'translateY(' + desde + 'px)', opacity: 0, offset: 0 },
          { transform: 'translateY(-10px)', opacity: 1, offset: .45, easing: 'ease-out' },
          { transform: 'translateY(4px)', opacity: 1, offset: .72, easing: 'ease-in-out' },
          { transform: 'translateY(-1.5px)', opacity: 1, offset: .88, easing: 'ease-in-out' },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
        ];
    el.style.opacity = 1;
    el.animate(kf, { duration: reducido ? 260 : 500, delay: retraso, easing: 'cubic-bezier(.3,.6,.4,1)', fill: 'backwards' });
  }

  function rebote(el) {
    if (!el || !el.animate) return;
    var kf = reducido
      ? [{ opacity: 1 }, { opacity: .6 }, { opacity: 1 }]
      : [{ transform: 'translateY(0)' }, { transform: 'translateY(-14px)', offset: .4, easing: 'ease-in' }, { transform: 'translateY(2px)', offset: .75 }, { transform: 'translateY(0)' }];
    el.animate(kf, { duration: reducido ? 260 : 380, easing: 'cubic-bezier(.22,1,.36,1)' });
  }

  function iniciar(el) {
    if (el.dataset.pfxHporListo) return;
    el.dataset.pfxHporListo = '1';
    var raiz = el.closest('.shopify-section') || el;
    el.classList.add('pfx-hpor--js');
    var escena = el.querySelector('[data-pfx-hpor-escena]');
    var imgs = [].slice.call(el.querySelectorAll('[data-pfx-hpor-pieza]'));
    var arrancado = false;

    function arrancar() {
      if (arrancado) return;
      arrancado = true;
      el.classList.add('is-in');
      var f = el.querySelector('[data-pfx-hpor-pieza="frasco"]');
      entrar(f, 0, 56);
      [].slice.call(el.querySelectorAll('[data-pfx-hpor-pieza="capsula"]')).forEach(function (c, i) {
        entrar(c, 330 + i * 130, -90);
      });
    }

    // Se espera la decodificación para que nada aparezca a medio cargar.
    Promise.all(imgs.map(function (i) { return i.decode ? i.decode().catch(function () {}) : Promise.resolve(); })).then(arrancar);
    setTimeout(arrancar, 2500);

    if (escena) {
      escena.addEventListener('click', function (e) {
        var cap = e.target.closest && e.target.closest('.pfx-hpor__capsula');
        rebote(cap ? cap.querySelector('img') : el.querySelector('[data-pfx-hpor-pieza="frasco"]'));
      });
    }
  }

  function todas() {
    [].slice.call(document.querySelectorAll('[data-pfx-hpor]')).forEach(iniciar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas); else todas();
  document.addEventListener('shopify:section:load', todas);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-home-rutina"] && !Shopify.designMode) return;
  try {
    
(function () {
  function miles(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function dinero(n) { return '$' + miles(n); }

  function iniciar(el) {
    if (el.dataset.pfxHrListo) return;
    el.dataset.pfxHrListo = '1';
    var rango = el.querySelector('.pfx-hr__rango');
    var packs = Array.prototype.slice.call(el.querySelectorAll('.pfx-hr__pack'));
    if (!rango || !packs.length) return;
    var paradas = Array.prototype.slice.call(el.querySelectorAll('.pfx-hr__parada'));
    var pista = el.querySelector('.pfx-hr__pista');
    var aviso = el.querySelector('.pfx-hr__aviso');
    var filas = Array.prototype.slice.call(el.querySelectorAll('.pfx-hr__fila')).map(function (f) {
      return Array.prototype.slice.call(f.children);
    });
    var dias = [].concat.apply([], filas);
    var total = packs.length;
    var actual = -1;
    var activos = 0;
    var cuentas = [];

    el.classList.add('pfx-hr--js');

    // Precio por mes, por día y valor de cuota: siempre salen del precio real del pack.
    packs.forEach(function (p) {
      var precio = parseFloat(p.dataset.precio) || 0;
      var meses = Math.max(1, parseFloat(p.dataset.meses) || 1);
      var cuotas = Math.max(1, parseFloat(p.dataset.cuotas) || 1);
      var v = { precio: precio, mes: precio / meses, dia: precio / (meses * 30), cuota: precio / cuotas };
      p.querySelectorAll('[data-cuenta]').forEach(function (b) {
        var r = b.getAttribute('data-rol');
        if (v[r] != null) b.setAttribute('data-cuenta', String(Math.round(v[r])));
        b.textContent = dinero(v[r]);
      });
      p.querySelector('[data-rol="precio"]').textContent = p.dataset.final || dinero(precio);
    });

    function contar(b, desde, hasta, final) {
      if (b._raf) cancelAnimationFrame(b._raf);
      var dur = 440, t0 = null;
      function paso(t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / dur);
        var e = 1 - Math.pow(1 - k, 3);
        b.textContent = k < 1 ? dinero(desde + (hasta - desde) * e) : (final || dinero(hasta));
        if (k < 1) b._raf = requestAnimationFrame(paso);
      }
      b._raf = requestAnimationFrame(paso);
    }

    // Enciende o apaga los días en cascada; el total de la cascada no pasa de 0,4 s.
    function pintar(meses) {
      var meta = Math.min(dias.length, meses * 30);
      var suben = [], bajan = [];
      dias.forEach(function (d, k) {
        var on = k < meta, ya = d.classList.contains('is-on');
        if (on && !ya) suben.push(d); else if (!on && ya) bajan.push(d);
      });
      suben.forEach(function (d, j) {
        d.style.transitionDelay = Math.round(j / Math.max(1, suben.length) * 210) + 'ms';
        d.classList.add('is-on');
      });
      bajan.reverse().forEach(function (d, j) {
        d.style.transitionDelay = Math.round(j / Math.max(1, bajan.length) * 150) + 'ms';
        d.classList.remove('is-on');
      });
      activos = meta;
    }

    function ir(i, primera) {
      i = Math.max(0, Math.min(total - 1, i));
      if (i === actual && !primera) return;
      var antes = actual >= 0 ? packs[actual] : null;
      var nuevo = packs[i];
      rango.value = String(i);
      if (pista) pista.style.setProperty('--pfx-hr-p', total > 1 ? String(i / (total - 1)) : '0');
      paradas.forEach(function (s, k) {
        s.classList.toggle('is-act', k === i);
        s.setAttribute('aria-pressed', k === i ? 'true' : 'false');
      });
      if (antes) antes.classList.remove('is-act');
      nuevo.classList.add('is-act');
      nuevo.querySelectorAll('[data-cuenta]').forEach(function (b) {
        var hasta = parseFloat(b.getAttribute('data-cuenta')) || 0;
        var rol = b.getAttribute('data-rol');
        var previo = antes ? antes.querySelector('[data-rol="' + rol + '"]') : null;
        var desde = previo ? (parseFloat(previo.getAttribute('data-cuenta')) || 0) : 0;
        contar(b, desde, hasta, rol === 'precio' ? nuevo.dataset.final : null);
      });
      var meses = parseFloat(nuevo.dataset.meses) || 1;
      pintar(meses);
      var m = paradas[i] ? paradas[i].querySelector('.pfx-hr__meses') : null;
      rango.setAttribute('aria-valuetext', (m ? m.textContent + ': ' : '') + (nuevo.dataset.final || ''));
      if (aviso && !primera) aviso.textContent = (m ? m.textContent + ', ' : '') + (nuevo.dataset.final || '');
      actual = i;
    }

    rango.addEventListener('input', function () { ir(parseInt(rango.value, 10) || 0); });
    paradas.forEach(function (s, k) { s.addEventListener('click', function () { ir(k); }); });

    var inicial = parseInt(rango.getAttribute('value'), 10) || 0;
    // Hasta que entra en pantalla los días quedan apagados: se encienden en cascada al verlos.
    dias.forEach(function (d) { d.classList.remove('is-on'); });
    packs.forEach(function (p) { p.classList.remove('is-act'); });
    function entrar() {
      el.classList.add('is-in');
      ir(inicial, true);
    }
    if (!('IntersectionObserver' in window)) { entrar(); return; }
    var io = new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) { entrar(); io.disconnect(); }
    }, { threshold: 0.2 });
    io.observe(el);
  }
  function todas() { document.querySelectorAll('[data-pfx-hr]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas); else todas();
  document.addEventListener('shopify:section:load', todas);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-home-trabaja"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(el) {
    if (el.dataset.pfxHtListo) return;
    el.dataset.pfxHtListo = '1';
    var tramos = Array.prototype.slice.call(el.querySelectorAll('.pfx-ht__tramo'));
    var pasos = Array.prototype.slice.call(el.querySelectorAll('.pfx-ht__paso'));
    var punto = el.querySelector('.pfx-ht__punto');
    var temporizadores = [];
    var terminado = false;

    el.classList.add('pfx-ht--js');
    // Arranca todo apagado: cada paso enciende y dibuja su tramo al entrar.
    tramos.forEach(function (t) { t.classList.remove('is-draw', 'is-on'); });
    pasos.forEach(function (p) { p.classList.remove('is-lit', 'is-act'); p.querySelector('.pfx-ht__btn').setAttribute('aria-pressed', 'false'); });
    function mover(i) {
      if (!punto || !tramos[i]) return;
      punto.style.transform = 'translateX(' + (parseFloat(tramos[i].getAttribute('data-x')) || 0) + 'px)';
    }
    if (punto) punto.style.transform = 'translateX(0px)';

    // Lleva el cauce hasta el paso i: los tramos hasta ahí se ven, los siguientes quedan tenues.
    function ir(i) {
      tramos.forEach(function (t, k) { t.classList.toggle('is-on', k <= i); });
      pasos.forEach(function (p, k) {
        p.classList.toggle('is-act', k === i);
        p.querySelector('.pfx-ht__btn').setAttribute('aria-pressed', k === i ? 'true' : 'false');
      });
      mover(i);
    }
    function encender(k) {
      if (tramos[k]) tramos[k].classList.add('is-draw');
      if (pasos[k]) pasos[k].classList.add('is-lit');
      ir(k);
    }
    function cerrar() {
      terminado = true;
      el.classList.add('is-fin');
    }
    function cortar() {
      temporizadores.forEach(clearTimeout);
      temporizadores = [];
      pasos.forEach(function (p, k) { if (tramos[k]) tramos[k].classList.add('is-draw'); p.classList.add('is-lit'); });
      if (!terminado) cerrar();
    }

    pasos.forEach(function (p, i) {
      p.querySelector('.pfx-ht__btn').addEventListener('click', function () {
        cortar();
        // Segundo clic sobre el paso ya activo vuelve a mostrar el cauce completo.
        ir(p.classList.contains('is-act') && i !== pasos.length - 1 ? pasos.length - 1 : i);
      });
    });

    function entrar() {
      el.classList.add('is-in');
      pasos.forEach(function (p, k) {
        temporizadores.push(setTimeout(function () { encender(k); }, 800 + k * 520));
      });
      temporizadores.push(setTimeout(cerrar, 800 + pasos.length * 520));
    }
    if (!('IntersectionObserver' in window)) { entrar(); return; }
    var io = new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) { entrar(); io.disconnect(); }
    }, { threshold: 0.25 });
    io.observe(el);
  }
  function todas() { document.querySelectorAll('[data-pfx-ht]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas); else todas();
  document.addEventListener('shopify:section:load', todas);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-inicio-cierre"] && !Shopify.designMode) return;
  try {
    
[].slice.call(document.querySelectorAll('[data-pfx-icr]')).forEach(function (s) {
  if (s.getAttribute('data-listo')) return;
  s.setAttribute('data-listo', '1');
  s.classList.add('is-js');
  function entrar() { s.classList.add('is-in'); setTimeout(function () { s.classList.add('is-hecho'); }, 900); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { entrar(); io.disconnect(); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    io.observe(s);
  } else { entrar(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-inicio-compra"] && !Shopify.designMode) return;
  try {
    
[].slice.call(document.querySelectorAll('[data-pfx-icm]')).forEach(function (s) {
  if (s.getAttribute('data-listo')) return;
  s.setAttribute('data-listo', '1');
  s.classList.add('is-js');
  var tabs = [].slice.call(s.querySelectorAll('.pfx-icm-tab'));
  var pans = [].slice.call(s.querySelectorAll('.pfx-icm-pan'));
  var DUR = 4500, timer = null, actual = 0, cortado = false, entro = false;

  function ir(i) {
    actual = i;
    tabs.forEach(function (t, j) {
      var a = j === i;
      t.classList.remove('is-act');
      if (a) { void t.offsetWidth; t.classList.add('is-act'); }
      t.setAttribute('aria-selected', a ? 'true' : 'false');
      t.tabIndex = a ? 0 : -1;
    });
    pans.forEach(function (p, j) {
      p.classList.remove('is-act');
      if (j === i) { void p.offsetWidth; p.classList.add('is-act'); }
    });
  }
  function programar() {
    clearTimeout(timer);
    if (cortado || tabs.length < 2) return;
    timer = setTimeout(function () { ir((actual + 1) % tabs.length); programar(); }, DUR);
  }
  // Una vez que la persona toca algo, el avance automático se corta para siempre.
  function cortar() {
    cortado = true; clearTimeout(timer);
    tabs.forEach(function (t) { t.classList.remove('is-auto'); });
  }
  tabs.forEach(function (t, j) {
    t.style.setProperty('--pfx-icm-dur', DUR + 'ms');
    t.addEventListener('click', function () { cortar(); ir(j); });
    t.addEventListener('keydown', function (e) {
      var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!d) return;
      e.preventDefault(); cortar();
      var n = (j + d + tabs.length) % tabs.length; ir(n); tabs[n].focus();
    });
  });
  ir(0);

  // Gesto al tocar: clase que se saca sola; sin preventDefault para no frenar el scroll.
  function toque(el, ms) {
    el.classList.remove('is-toca'); void el.offsetWidth; el.classList.add('is-toca');
    clearTimeout(el._pfxT);
    el._pfxT = setTimeout(function () { el.classList.remove('is-toca'); }, ms);
  }
  var sello = s.querySelector('.pfx-icm-sello');
  if (sello) sello.addEventListener('pointerdown', function () { toque(sello, 480); }, { passive: true });
  pans.forEach(function (p) {
    var g = p.querySelector('.pfx-icm-grande');
    if (g) g.addEventListener('pointerdown', function () { toque(g, 380); }, { passive: true });
  });
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      var g = pans[tabs.indexOf(t)] && pans[tabs.indexOf(t)].querySelector('.pfx-icm-grande');
      if (g) toque(g, 380);
    });
  });

  // Cuenta del sello: setTimeout y no rAF, que se frena en segundo plano.
  var num = s.querySelector('[data-cuenta]');
  function contar() {
    if (!num) return;
    var meta = parseInt(num.getAttribute('data-cuenta'), 10) || 0, k = 0;
    (function paso() {
      k++;
      num.textContent = Math.round(meta * (1 - Math.pow(1 - k / 12, 3)));
      if (k < 12) setTimeout(paso, 36);
    })();
  }
  function entrar() {
    if (entro) return; entro = true;
    s.classList.add('is-in'); contar();
    if (s.getAttribute('data-auto') === 'true' && tabs.length > 1) {
      tabs.forEach(function (t) { t.classList.add('is-auto'); });
      ir(0); programar();
    }
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { entrar(); io.disconnect(); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    io.observe(s);
  } else { entrar(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-inicio-formula"] && !Shopify.designMode) return;
  try {
    
[].slice.call(document.querySelectorAll('[data-pfx-ifo]')).forEach(function (s) {
  if (s.getAttribute('data-listo')) return;
  s.setAttribute('data-listo', '1');
  // La clase que oculta la pone JS: sin JS todo queda visible.
  s.classList.add('is-js');
  // Táctil: no hay hover, así que el toque pone una clase que se saca sola.
  [].slice.call(s.querySelectorAll('.pfx-ifo-activo')).forEach(function (a) {
    var t = 0;
    a.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      a.classList.add('is-tap'); clearTimeout(t);
      t = setTimeout(function () { a.classList.remove('is-tap'); }, 450);
    });
  });
  var entro = false;
  function entrar() { if (entro) return; entro = true; s.classList.add('is-in'); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { entrar(); io.disconnect(); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    io.observe(s);
  } else { entrar(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-inicio-franja"] && !Shopify.designMode) return;
  try {
    
[].slice.call(document.querySelectorAll('[data-pfx-ifr]')).forEach(function (s) {
  if (s.getAttribute('data-listo')) return;
  s.setAttribute('data-listo', '1');
  s.classList.add('is-js');
  function entrar() { s.classList.add('is-in'); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { entrar(); io.disconnect(); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    io.observe(s);
  } else { entrar(); }
  // Dos clases que se alternan: cambiar el nombre de la animación es lo que la reinicia en cada toque.
  [].slice.call(s.querySelectorAll('.pfx-ifr-item')).forEach(function (it) {
    var n = 0;
    it.addEventListener('pointerdown', function () {
      it.classList.remove('toca-a', 'toca-b');
      void it.offsetWidth;
      it.classList.add(n++ % 2 ? 'toca-b' : 'toca-a');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-inicio-opiniones"] && !Shopify.designMode) return;
  try {
    
[].slice.call(document.querySelectorAll('[data-pfx-iop]')).forEach(function (s) {
  if (s.getAttribute('data-listo')) return;
  s.setAttribute('data-listo', '1');
  s.classList.add('is-js');
  var entro = false;
  var cuenta = s.querySelector('[data-cuenta]');
  function contar() {
    if (!cuenta) return;
    var meta = parseInt(cuenta.getAttribute('data-cuenta'), 10) || 0, k = 0;
    (function paso() {
      k++;
      cuenta.textContent = Math.round(meta * (1 - Math.pow(1 - k / 14, 3)));
      if (k < 14) setTimeout(paso, 32);
    })();
  }
  function entrar() { if (entro) return; entro = true; s.classList.add('is-in'); contar(); setTimeout(function () { s.classList.add('is-hecho'); }, 1000); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { entrar(); io.disconnect(); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    io.observe(s);
  } else { entrar(); }

  // La fila de fotos entra cuando ella misma se ve, no con la sección.
  var filaF = s.querySelector('.pfx-iop-fotos');
  if (filaF) {
    if ('IntersectionObserver' in window) {
      var iof = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { filaF.classList.add('is-in'); iof.disconnect(); } });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
      iof.observe(filaF);
    } else { filaF.classList.add('is-in'); }
  }

  // Gesto al tocar: la clase se saca sola; no se frena el toque ni el scroll.
  function toque(el, ms) {
    el.classList.remove('is-toca');
    void el.offsetWidth;
    el.classList.add('is-toca');
    clearTimeout(el._pfxT);
    el._pfxT = setTimeout(function () { el.classList.remove('is-toca'); }, ms);
  }
  [].slice.call(s.querySelectorAll('.pfx-iop-op')).forEach(function (o) {
    o.addEventListener('pointerdown', function () { toque(o, 500); }, { passive: true });
    o.addEventListener('pointerenter', function (ev) { if (ev.pointerType === 'mouse') toque(o, 500); }, { passive: true });
  });
  [].slice.call(s.querySelectorAll('.pfx-iop-foto')).forEach(function (o) {
    o.addEventListener('pointerdown', function () { toque(o, 450); }, { passive: true });
  });
  var cu = s.querySelector('.pfx-iop-cuenta');
  if (cu) cu.addEventListener('pointerdown', function () { toque(cu, 300); }, { passive: true });

  // Puntos de cada carrusel en celular: marcan la tarjeta más cercana al centro.
  function carrusel(pista, puntos, items) {
    if (!pista || !puntos.length) return;
    var t = null;
    pista.addEventListener('scroll', function () {
      if (t) clearTimeout(t);
      t = setTimeout(function () {
        var c = pista.scrollLeft + pista.clientWidth / 2, mejor = 0, d = 1e9;
        items.forEach(function (o, j) { var x = Math.abs(o.offsetLeft + o.offsetWidth / 2 - c); if (x < d) { d = x; mejor = j; } });
        puntos.forEach(function (p, j) { p.classList.toggle('is-act', j === mejor); });
        items.forEach(function (o, j) { o.classList.toggle('is-lejos', j !== mejor); });
      }, 60);
    }, { passive: true });
    setTimeout(function () { items.forEach(function (o, j) { if (j) o.classList.add('is-lejos'); }); }, 1100);
  }
  carrusel(s.querySelector('.pfx-iop-mosaico'), [].slice.call(s.querySelectorAll('.pfx-iop-puntos:not(.pfx-iop-puntos--f) i')), [].slice.call(s.querySelectorAll('.pfx-iop-op')));
  carrusel(filaF, [].slice.call(s.querySelectorAll('.pfx-iop-puntos--f i')), [].slice.call(s.querySelectorAll('.pfx-iop-foto')));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-inicio-pasos"] && !Shopify.designMode) return;
  try {
    
[].slice.call(document.querySelectorAll('[data-pfx-ips]')).forEach(function (s) {
  if (s.getAttribute('data-listo')) return;
  s.setAttribute('data-listo', '1');
  // La clase que oculta la pone JS: sin JS todo queda visible.
  s.classList.add('is-js');
  // Táctil: sin hover, el toque pone una clase que se saca sola.
  [].slice.call(s.querySelectorAll('.pfx-ips-paso')).forEach(function (p) {
    var t = 0;
    p.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      p.classList.add('is-tap'); clearTimeout(t);
      t = setTimeout(function () { p.classList.remove('is-tap'); }, 450);
    });
  });
  var entro = false;
  function entrar() { if (entro) return; entro = true; s.classList.add('is-in'); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { entrar(); io.disconnect(); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    io.observe(s);
  } else { entrar(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-inicio-plan"] && !Shopify.designMode) return;
  try {
    
[].slice.call(document.querySelectorAll('[data-pfx-ipl]')).forEach(function (s) {
  if (s.getAttribute('data-listo')) return;
  s.setAttribute('data-listo', '1');
  // La clase que oculta la pone JS: sin JS todo queda visible.
  s.classList.add('is-js');
  var ops = [].slice.call(s.querySelectorAll('.pfx-ipl-op'));
  var boton = s.querySelector('.pfx-ipl-boton');
  var base = boton ? boton.getAttribute('href') : '';
  var actual = -1;
  var curva = 'cubic-bezier(.2,.8,.2,1)', resorte = 'cubic-bezier(.34,1.56,.64,1)';
  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Con WAAPI el estado final es siempre el del CSS: si la pestaña está en segundo plano nada queda oculto.
  function mover(el, cuadros, opc) { if (el && el.animate) { try { el.animate(cuadros, opc); } catch (e) {} } }
  function reaccion(i) {
    var op = ops[i], k = reducido ? 0.45 : 1;
    if (!op) return;
    [].slice.call(op.querySelectorAll('.pfx-ipl-frascos > span')).forEach(function (fr, n) {
      mover(fr, [{ transform: 'translateY(' + (-16 * k) + 'px) scale(.92)', opacity: 0 }, { transform: 'translateY(0) scale(1)', opacity: 1 }],
        { duration: 260, delay: n * 45, easing: resorte, fill: 'backwards' });
    });
    mover(op.querySelector('.pfx-ipl-precio b'), [{ transform: 'translateY(' + (10 * k) + 'px)', opacity: 0 }, { transform: 'none', opacity: 1 }],
      { duration: 220, delay: 60, easing: curva, fill: 'backwards' });
    mover(op.querySelector('.pfx-ipl-chip'), [{ transform: 'scale(.85)' }, { transform: 'scale(1)' }],
      { duration: 240, delay: 100, easing: resorte, fill: 'backwards' });
    if (boton) {
      mover(boton, [{ transform: 'scale(1)' }, { transform: 'scale(' + (reducido ? 1.025 : 1.05) + ')' }, { transform: 'scale(1)' }], { duration: 300, delay: 120, easing: curva });
      mover(boton.querySelector('i'), [{ transform: 'translateX(0)' }, { transform: 'translateX(' + (8 * k) + 'px)' }, { transform: 'translateX(0)' }], { duration: 300, delay: 120, easing: curva });
    }
  }
  function elegir(i) {
    var cambio = actual !== -1 && i !== actual;
    actual = i;
    ops.forEach(function (o, k) {
      o.classList.toggle('is-act', k === i);
      o.setAttribute('aria-pressed', k === i ? 'true' : 'false');
    });
    var h = ops[i] && ops[i].getAttribute('data-href');
    if (boton) boton.setAttribute('href', h || base);
    if (cambio) reaccion(i);
  }
  ops.forEach(function (o, i) { o.addEventListener('click', function () { elegir(i); }); });
  elegir(parseInt(s.getAttribute('data-ini'), 10) || 0);
  var entro = false;
  function entrar() { if (entro) return; entro = true; s.classList.add('is-in'); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { entrar(); io.disconnect(); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    io.observe(s);
  } else { entrar(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-inicio-portada"] && !Shopify.designMode) return;
  try {
    
/* La foto late donde se la toca. Se escucha en toda la sección porque el velo y el texto la tapan; los enlaces y el texto no cuentan. */
[].slice.call(document.querySelectorAll('[data-pfx-ipo]')).forEach(function (s) {
  if (s.getAttribute('data-listo')) return;
  s.setAttribute('data-listo', '1');
  var foto = s.querySelector('.pfx-ipo-foto');
  if (!foto) return;
  s.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('a, h1, p')) return;
    var r = foto.getBoundingClientRect();
    foto.style.setProperty('--pfx-ipo-ox', Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100)) + '%');
    foto.style.setProperty('--pfx-ipo-oy', Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100)) + '%');
    foto.classList.remove('is-toca'); void foto.offsetWidth; foto.classList.add('is-toca');
  });
  foto.addEventListener('animationend', function (e) { if (e.target === foto) foto.classList.remove('is-toca'); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-inicio-preguntas"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(el) {
    if (el.dataset.pfxFaqListo) return;
    el.dataset.pfxFaqListo = '1';
    var items = Array.prototype.slice.call(el.querySelectorAll('.pfx-ipq__item'));
    var soloUna = el.getAttribute('data-una') !== 'false';
    var primera = el.getAttribute('data-primera') === 'true';

    // Al abrir una pregunta se cierra otra y, si la cerrada está arriba, la página subiría bajo el dedo: se compensa mientras dura la transición.
    function anclar(b) {
      var y0 = b.getBoundingClientRect().top, fin = Date.now() + 360;
      (function paso() {
        var d = b.getBoundingClientRect().top - y0;
        if (d > 0.5 || d < -0.5) window.scrollBy({ top: d, left: 0, behavior: 'instant' });
        if (Date.now() < fin) requestAnimationFrame(paso);
      })();
    }
    function poner(item, abierto) {
      item.classList.toggle('is-open', abierto);
      var b = item.querySelector('.pfx-ipq__q');
      if (b) b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    }
    // Sin JS todo queda abierto; recién acá se cierran las que corresponde.
    el.classList.add('pfx-ipq--js');
    items.forEach(function (it, i) {
      poner(it, primera && i === 0);
      var b = it.querySelector('.pfx-ipq__q');
      if (!b) return;
      b.addEventListener('click', function () {
        var abrir = !it.classList.contains('is-open');
        if (abrir && soloUna) anclar(b);
        if (abrir && soloUna) items.forEach(function (o) { if (o !== it) poner(o, false); });
        poner(it, abrir);
      });
    });

    if (!('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) { el.classList.add('is-in'); io.disconnect(); }
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    io.observe(el);
  }
  function todas() { document.querySelectorAll('[data-pfx-ipq]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas); else todas();
  document.addEventListener('shopify:section:load', todas);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-inicio-sintomas"] && !Shopify.designMode) return;
  try {
    
[].slice.call(document.querySelectorAll('[data-pfx-isi]')).forEach(function (s) {
  if (s.getAttribute('data-listo')) return;
  s.setAttribute('data-listo', '1');
  s.classList.add('is-js');
  function entrar() { s.classList.add('is-in'); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { entrar(); io.disconnect(); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    io.observe(s);
  } else { entrar(); }
  // El estado de toque dura un mínimo aunque el dedo suelte enseguida, si no el gesto no alcanza a verse.
  [].slice.call(s.querySelectorAll('.pfx-isi-frase')).forEach(function (f) {
    var t = null;
    function soltar() { clearTimeout(t); t = setTimeout(function () { f.classList.remove('is-toca'); }, 420); }
    f.addEventListener('pointerdown', function () { clearTimeout(t); f.classList.add('is-toca'); });
    f.addEventListener('pointerup', soltar);
    f.addEventListener('pointercancel', function () { clearTimeout(t); f.classList.remove('is-toca'); });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-opiniones"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(el) {
    if (el.dataset.pfxOpListo) return;
    el.dataset.pfxOpListo = '1';
    var lista = el.querySelector('[data-pfx-op-lista]');
    var cards = lista ? Array.prototype.slice.call(lista.querySelectorAll('.pfx-op__card')) : [];
    var visibles = parseInt(el.getAttribute('data-visibles'), 10) || 6;
    var boton = el.querySelector('[data-pfx-op-mas]');
    var puntos = el.querySelector('[data-pfx-op-puntos]');
    var num = el.querySelector('[data-pfx-op-num]');
    var final = parseFloat(el.getAttribute('data-prom')) || 0;

    // Sólo las primeras; el resto aparece con «Ver más». Sin JS se ven todas.
    if (boton && cards.length > visibles) {
      cards.forEach(function (c, i) { if (i >= visibles) c.hidden = true; });
      boton.hidden = false;
      boton.addEventListener('click', function () {
        cards.forEach(function (c, i) {
          if (c.hidden) { c.hidden = false; c.style.setProperty('--pfx-op-d', ((i - visibles) % 6) * 50 + 'ms'); c.classList.add('is-nueva'); }
        });
        boton.hidden = true;
        medirLeer();
        if (marcar) marcar();
      });
    }

    // El mismo botón del hero: se copia para no duplicar precio ni lógica de carrito, y el clic va al original.
    var cta = el.querySelector('[data-pfx-op-cta]');
    var original = document.querySelector('.pfx-hero__boton');
    if (cta && original) {
      var copia = original.cloneNode(true);
      copia.type = 'button';
      copia.classList.remove('pfx-hero__entra');
      copia.removeAttribute('style');
      var estilo = getComputedStyle(original);
      ['--h-marino', '--h-azul'].forEach(function (v) { cta.style.setProperty(v, estilo.getPropertyValue(v)); });
      var precioO = original.querySelector('[data-pfx-precio-boton]');
      var precioC = copia.querySelector('[data-pfx-precio-boton]');
      if (precioC) precioC.removeAttribute('data-pfx-precio-boton');
      if (precioO && precioC) new MutationObserver(function () { precioC.textContent = precioO.textContent; }).observe(precioO, { childList: true, characterData: true, subtree: true });
      copia.addEventListener('click', function () { original.click(); });
      cta.appendChild(copia);
    }
    function medirLeer() {
      el.querySelectorAll('[data-pfx-op-leer]').forEach(function (b) {
        var texto = b.previousElementSibling;
        if (texto && !texto.classList.contains('is-abierto')) b.hidden = texto.scrollHeight <= texto.clientHeight + 1;
      });
    }
    el.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-pfx-op-leer]') : null;
      if (!b) return;
      b.previousElementSibling.classList.add('is-abierto');
      b.hidden = true;
    });
    medirLeer();
    window.addEventListener('resize', medirLeer, { passive: true });

    // Puntitos del carrusel de celular (contador si son muchas).
    var dots = [];
    var contador = null;
    if (puntos && cards.length > 1) {
      if (cards.length > 10) {
        contador = document.createElement('span');
        puntos.appendChild(contador);
      } else {
        cards.forEach(function () { var d = document.createElement('span'); d.className = 'pfx-op__punto'; puntos.appendChild(d); dots.push(d); });
      }
      var marcar = function () {
        var primero = cards[0], paso = (cards[1].offsetLeft - primero.offsetLeft) || 1;
        var i = Math.max(0, Math.min(cards.length - 1, Math.round(lista.scrollLeft / paso)));
        if (contador) contador.textContent = (i + 1) + ' / ' + cards.length;
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); d.style.display = cards[k].hidden ? 'none' : ''; });
      };
      lista.addEventListener('scroll', function () { window.requestAnimationFrame(marcar); }, { passive: true });
      marcar();
    }

    // Carrusel de celular: con mouse también se arrastra (con el dedo ya desliza solo).
    if (lista) {
      var abajo = false, x0 = 0, s0 = 0;
      lista.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || lista.scrollWidth <= lista.clientWidth + 2) return;
        abajo = true; x0 = e.clientX; s0 = lista.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!abajo) return;
        lista.classList.add('is-arrastra');
        lista.style.scrollSnapType = 'none';
        lista.scrollLeft = s0 - (e.clientX - x0);
      });
      window.addEventListener('pointerup', function () {
        if (!abajo) return;
        abajo = false;
        lista.classList.remove('is-arrastra');
        lista.style.scrollSnapType = '';
      });
    }

    if (!('IntersectionObserver' in window)) return;
    el.classList.add('pfx-op--js');
    cards.forEach(function (c, i) { c.style.setProperty('--pfx-op-d', 193 + Math.min(i, 8) * 44 + 'ms'); });
    if (num) num.textContent = '0,0';

    function contarNota() {
      if (!num || !final) return;
      var t0 = null, dur = 770;
      (function paso(t) {
        if (t0 === null) t0 = t;
        var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
        num.textContent = (final * e).toFixed(1).replace('.', ',');
        if (p < 1) requestAnimationFrame(paso); else num.classList.add('is-pop');
      })(performance.now());
    }
    var io = new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) { el.classList.add('is-in'); io.disconnect(); setTimeout(contarNota, 275); }
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    io.observe(el);
  }
  function todas() { document.querySelectorAll('[data-pfx-op]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas); else todas();
  document.addEventListener('shopify:section:load', todas);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-pasos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(sec) {
      if (sec.getAttribute('data-listo')) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) sec.setAttribute('data-reducido', '');
      sec.setAttribute('data-listo', '1');
      // La flecha va centrada en la foto: se mide el alto de la foto de cada paso.
      function medir() {
        [].forEach.call(sec.querySelectorAll('.pfx-pa__paso'), function (p) {
          var f = p.querySelector('.pfx-pa__foto');
          if (f) p.style.setProperty('--pa-alto-foto', f.offsetHeight + 'px');
        });
      }
      medir();
      window.addEventListener('resize', medir);
      window.addEventListener('load', medir);
      function entrar() { sec.classList.add('is-vista'); }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) { entrar(); io.disconnect(); }
        }, { threshold: 0.12 });
        io.observe(sec);
      } else { entrar(); }
    }
    function todo() { [].forEach.call(document.querySelectorAll('[data-pfx-pa]'), iniciar); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo();
    document.addEventListener('shopify:section:load', todo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-que-paso"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(raiz) {
      raiz.querySelectorAll('[data-pfx-qp]:not([data-pfx-listo])').forEach(function (seccion) {
        seccion.setAttribute('data-pfx-listo', '');
        // En el editor de temas se muestra directo; en la tienda entra al aparecer en pantalla (una sola vez, sin seguir al scroll).
        if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) return;
        seccion.classList.add('pfx-qp--oculta');
        var io = new IntersectionObserver(function (entradas) {
          if (!entradas.some(function (e) { return e.isIntersecting; })) return;
          io.disconnect();
          // Dos cuadros para que el navegador pinte el estado inicial antes de la transición.
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              seccion.classList.add('pfx-qp--lista');
              seccion.classList.remove('pfx-qp--oculta');
            });
          });
        }, { threshold: 0.15 });
        io.observe(seccion);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
    else iniciar(document);
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-raiz"] && !Shopify.designMode) return;
  try {
    
(function(){
  function iniciar(s){
    if(s.getAttribute('data-listo'))return;
    s.setAttribute('data-listo','1');
    if(!('IntersectionObserver' in window)||(window.Shopify&&window.Shopify.designMode))return;
    s.classList.add('pfx-js');
    var io=new IntersectionObserver(function(es){
      if(!es.some(function(e){return e.isIntersecting;}))return;
      io.disconnect();
      requestAnimationFrame(function(){requestAnimationFrame(function(){s.classList.add('pfx-in');});});
    },{threshold:.08});
    io.observe(s);
  }
  function todas(){[].forEach.call(document.querySelectorAll('[data-pfx-rz]'),iniciar);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',todas);else todas();
  document.addEventListener('shopify:section:load',todas);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfx-transformacion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(sec) {
      if (sec.getAttribute('data-listo')) return;
      sec.setAttribute('data-listo', '1');
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) sec.setAttribute('data-reducido', '');
      if (!('IntersectionObserver' in window)) return;
      sec.classList.add('pfx-tl--js', 'pfx-tl--oculta');
      var obs = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        sec.classList.remove('pfx-tl--oculta');
        obs.disconnect();
      }, { threshold: 0.15 });
      obs.observe(sec);
    }
    function todas() { [].forEach.call(document.querySelectorAll('[data-pfx-tl]'), iniciar); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas); else todas();
    document.addEventListener('shopify:section:load', todas);
  })();

  } catch(e) { console.error(e); }
})();
})();
